import { ItemType } from "../defines/enums"
import { GizmoDefaults } from "../defines/values"
import { Gizmo } from "../entity/items/gizmo"
import { Player } from "../player/player"

export function buildGizmo(type: ItemType, player: Player): Gizmo | undefined {
  let gizmo: Gizmo | undefined = undefined
  switch (type) {
    case ItemType.EQUIPMENT_GIZMO1:
      gizmo = new Gizmo(ItemType.EQUIPMENT_GIZMO1, 0, 0, player)
      break
    case ItemType.EQUIPMENT_GIZMO2:
      gizmo = new Gizmo(ItemType.EQUIPMENT_GIZMO2, 0, 0, player)
      break
    case ItemType.EQUIPMENT_GIZMO3:
      gizmo = new Gizmo(
        ItemType.EQUIPMENT_GIZMO3,
        GizmoDefaults.GIZMO3.ACTIVE,
        GizmoDefaults.GIZMO3.COOLDOWN,
        player
      )
      break
    case ItemType.EQUIPMENT_GIZMO4:
      gizmo = new Gizmo(
        ItemType.EQUIPMENT_GIZMO4,
        GizmoDefaults.GIZMO4.ACTIVE,
        GizmoDefaults.GIZMO4.COOLDOWN,
        player
      )
      break
    case ItemType.EQUIPMENT_GIZMO5:
      gizmo = new Gizmo(
        ItemType.EQUIPMENT_GIZMO5,
        GizmoDefaults.GIZMO5.ACTIVE,
        GizmoDefaults.GIZMO5.COOLDOWN,
        player
      )
      break
  }
  return gizmo
}
